import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/calendar-off.vue
var s = {
	name: "DtIconCalendarOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--calendar-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Calendar Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M4.75 1.5a.5.5 0 0 0 0 1H7.5V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .5.5v1.5H7.75a.5.5 0 0 0 0 1H10v2.25a.5.5 0 0 0 1 0V3a1.5 1.5 0 0 0-1.5-1.5h-1V1a.5.5 0 0 0-1 0v.5H4.75Z" }, null, -1), i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M9.501 11.5a1.5 1.5 0 0 0 .95-.342l.195.196a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.707.706-.112.126A1.5 1.5 0 0 0 1 3v7a1.5 1.5 0 0 0 1.5 1.5h7.001ZM2 10a.5.5 0 0 0 .5.5h6.999c.082 0 .163-.02.235-.06L4.793 5.5H2V10Zm0-5.5V3a.5.5 0 0 1 .06-.234L3.792 4.5H2Z"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=calendar-off.js.map